import React from "react";
import {Form} from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import useSkFieldValidInvalid from "../useSkFieldValidInvalid";
import SkFieldProps from "./SkFieldProps";
import SkFieldDescriptionBlock from "./SkFieldDescriptionBlock";

const SkFieldCheckbox:React.FC<SkFieldProps> = (props) => {
  const {isInvalid} = useSkFieldValidInvalid(props);

  return (
    <Form.Group controlId={props.name}>
      <Form.Check
        type="checkbox"
        id={props.name}
        label={ReactHtmlParser(props.label || props.name)}
        checked={props.formikProps.values[props.name] === "checked"}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          props.formikProps.setFieldValue(props.name, e.target.checked ? "checked" : "");
        }}
        isInvalid={isInvalid}
        disabled={props.disabled || props.formikProps.isSubmitting}
      />
      <SkFieldDescriptionBlock
        description={props.description}
        isInvalid={isInvalid}
        errorText={`${props.formikProps.errors[props.name]}`}
      />
    </Form.Group>
  );
};

export default SkFieldCheckbox;
